import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege, getTokenInfo } from "../api/token";
import PasswordCard from "../components/PasswordCard";

export default function ChangePassword() {
  const navigate = useNavigate();
  const params = useParams();
  const users_edit = hasPrivilege('users_edit') || params.uuid === getTokenInfo().uuid;

  useEffect(() => {
    if (!users_edit) {
      navigate("/");
    }
  }, [navigate, users_edit])

  if (users_edit) {
    const editable = true;
    const ident = params.uuid;

    return (
      <div>
        <PasswordCard editable={editable} ident={ident} />
      </div>
    )
  }
}
